import { Component, OnInit } from '@angular/core';
import { KeycloakEventType, KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { userProfilDto } from './models/userProfilDto';
import { shareOpeSevices } from './services/sharedservices/shareOpe.services';
import { AuthService } from './services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { collabService } from './services/collab/collabService.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'extranet-vendeur-front';

  userprofilshare: userProfilDto = {
    nom: '',
    prenom: '',
    role: [],
    enable: true,
    mail: ''

  }
  userRole!: string[];

  public profile?: KeycloakProfile;
  constructor(public router: Router, public keycloakService: KeycloakService, public share: shareOpeSevices, private readonly collabservice: collabService,

    private authService: AuthService) {

  }
  ngOnInit() {

    // Injection dynamique du script Google Maps
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}`;
    script.async = true;
    document.head.appendChild(script);


    /**
     * conrol version for localstorage
     */
    const storageVersion = window.localStorage.getItem('version');
    if (storageVersion !== environment.version) {
      window.localStorage.clear();
      window.localStorage.setItem("version", environment.version);
    }


    //if(this.keycloakService.isLoggedIn()){

    this.keycloakService.loadUserProfile().then(

      profile => {

        this.profile = profile;

        this.userprofilshare.prenom = this.profile.firstName;
        this.userprofilshare.nom = this.profile.lastName;
        this.userprofilshare.mail = this.profile.email;
        this.userprofilshare.enable = this.profile.enabled;
        this.userprofilshare.role = this.keycloakService.getUserRoles();
        this.userRole = this.userprofilshare.role;

        const currentURL = window.location.pathname;
        if (currentURL === '/page-entites') this.router.navigate([`/page-entites`]);
        else if (currentURL === '/page-vendeurs') this.router.navigate([`/page-vendeurs`]);
        else if (currentURL === '/page-pitupload') this.router.navigate([`/page-pitupload`]);
        else if (currentURL === '/page-programme-piupload') this.router.navigate([`/page-pitupload`]);
        else if (currentURL === '/page-options') this.router.navigate([`/page-options`]);
        else if (this.hasRole('admin') || this.hasRole('interne') || this.hasRole('externe')) this.router.navigate([`/accueil`]);
        else if (this.hasRole('pit')) this.router.navigate([`/page-pitupload`]);

        this.collabservice.getCollabByEmail(this.profile.email).subscribe(
          data => { if (data.actif === "0") this.keycloakService.logout(); }
        );

        this.share.sendUserProfil(this.userprofilshare);


      });

    this.authService.logoutEvent.subscribe(() => {
      this.keycloakService.logout(window.location.protocol + "//" + window.location.host + "/accueil");
    });
    this.keycloakService.keycloakEvents$.subscribe(event => {
      if (event.type === KeycloakEventTypeLegacy.OnAuthLogout) {
        // Gérer la déconnexion de l'utilisateur
        //rediriger vers la page de connexion
        //this.keycloakService.logout(window.location.origin);
        this.keycloakService.logout(window.location.protocol + "//" + window.location.host + "/accueil");
      }
    });
  }
  async login() {
    await this.keycloakService.login({
      redirectUri: window.location.origin
    });
  }

  logout() {
    //this.keycloakService.logout(window.location.origin+"/accueil")

    this.keycloakService.logout(window.location.protocol + "//" + window.location.host + "/accueil");
  }

  hasRole(role: string): boolean {

    if (this.userRole && this.userRole.length > 0) {
      return this.userRole.includes(role);
    }
    return false;
  }
}
